import angular from 'angular';
import uiRouter from 'angular-ui-router';
import assignationComponent from './assignation.component';

const assignationModule = angular
  .module('assignation', [uiRouter])
  .config([
    '$stateProvider',
    ($stateProvider): void => {
      'ngInject';
      $stateProvider.state('newAssignation', {
        url: '/assignations/new?:operationId&:operationProcedureId',
        component: 'assignation',
        parent: 'main',
        data: {
          permissions: {
            only: ['AUTHORIZED'],
            redirectTo: 'home'
          }
        },
        resolve: {
          operation: [
            '$stateParams',
            'OperationsService',
            ($stateParams, OperationsService): Promise<any> => {
              return OperationsService.findOne({
                filter: {
                  where: {
                    id: $stateParams.operationId
                  },
                  include: ['vehicle', 'holder', 'operationProcedures']
                }
              });
            }
          ]
        }
      });
      $stateProvider.state('editAssignation', {
        url: '/assignations/:id',
        component: 'assignation',
        parent: 'main',
        data: {
          permissions: {
            only: ['AUTHORIZED'],
            redirectTo: 'home'
          }
        },
        resolve: {
          assignation: [
            '$stateParams',
            'AssignationsService',
            ($stateParams, AssignationsService): Promise<any> => {
              return AssignationsService.findOne({
                filter: {
                  where: {
                    id: $stateParams.id
                  },
                  include: [
                    {
                      relation: 'operation',
                      scope: {
                        include: ['vehicle', 'holder', 'operationProcedures']
                      }
                    },
                    'worker',
                    'registry',
                    'createdByUser',
                    'updatedByUser',
                    'operationProcedure'
                  ]
                }
              });
            }
          ]
        }
      });
    }
  ])
  .component('assignation', assignationComponent).name;

export default assignationModule;
